import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormsModule,  ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ClarityModule } from '@clr/angular';
import { PipesModule } from './pipes/pipes.module';


const MODULES = [
    ClarityModule,
    CommonModule,
    FormsModule,
    PipesModule,
    ReactiveFormsModule,
    RouterModule
];

@NgModule({
    imports: [
        ...MODULES
    ],
    declarations: [],
    exports: [
        ...MODULES
    ],
    providers: [
        FormBuilder
    ],
})
export class SharedModule {
}